import { render, staticRenderFns } from "./Simplecontent.vue?vue&type=template&id=e2164d3c&"
import script from "./Simplecontent.vue?vue&type=script&lang=js&"
export * from "./Simplecontent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports